import { Editor } from '@tiptap/core'
import { ReactRenderer } from '@tiptap/react'
import { Node } from 'prosemirror-model'
import { Plugin, PluginKey } from 'prosemirror-state'
import { CommentFieldIconWidget } from './CommentFieldIconWidget'

export function commentIconPlugin(editor: Editor, handleCommentSubmit: () => void) {
  let iconElement: HTMLElement | null = null

  return new Plugin({
    key: new PluginKey('commentIcon'),
    view: (view) => {
      const container = view.dom.parentElement
      const renderer = new ReactRenderer(CommentFieldIconWidget, {
        props: { isEmpty: editor.isEmpty, handleCommentSubmit },
        editor,
      })

      if (container) {
        iconElement = document.createElement('div')
        iconElement.style.position = 'absolute'
        iconElement.style.right = '6px'
        iconElement.style.top = '4px'

        iconElement.appendChild(renderer.element)
        container.appendChild(iconElement)
      }

      return {
        update: () => {
          if (iconElement) {
            const isEmpty = editor.isEmpty
            const isFocused = editor.isFocused

            iconElement.style.display = !isEmpty || isFocused ? 'block' : 'none'

            // Update props if needed
            renderer.updateProps({ isEmpty })
          }
        },
        destroy: () => {
          if (iconElement && iconElement.parentElement) {
            iconElement.parentElement.removeChild(iconElement)
          }
        },
      }
    },
  })
}

export function parseMentions(doc: Node): string[] {
  const result: string[] = []

  doc.descendants((node) => {
    if (node.type.name === 'mention') {
      result.push(node.attrs.id)
    }
  })

  return result
}
